export enum OwnerColumnFilter {
  ACTION_OWNER = 'Action Owner',
  ISSUE_OWNER = 'Issue Owner',
}

export enum TitleColumnFilter {
  ACTION_TITLE = 'Action Title',
  ISSUE_TITLE = 'Issue Title',
}

export enum ApproverColumnFilter {
  ACTION_APPROVER = 'Action Approver',
  ISSUE_APPROVER = 'Issue Approver',
}
